import {useEffect} from "react";
import {useQueryClient} from "@tanstack/react-query";
import {useIntl} from "react-intl";
import {toast} from "react-toastify";

// Queries opt into a user-facing error toast via `meta: {errorMessageId}`.
// Toasting here (once per failed fetch) instead of inside each hook means a
// query used by several components still shows a single toast.
const QueryErrorNotifier = () => {
    const queryClient = useQueryClient();
    const intl = useIntl();

    useEffect(() => queryClient.getQueryCache().subscribe((event) => {
        if (event?.type !== "updated" || event.action?.type !== "error") {
            return;
        }
        const messageId = event.query?.meta?.errorMessageId;
        if (messageId) {
            console.error(`Query ${JSON.stringify(event.query.queryKey)} failed`, event.action.error);
            toast.error(intl.formatMessage({id: messageId}));
        }
    }), [queryClient, intl]);

    return null;
};

export default QueryErrorNotifier;
